import React from 'react';
import { Modal, Icon } from 'antd';
import moment from 'moment';

function getModalIcon(type, icon){
    if(type == "success") {
        return <Icon type="check-circle" style={{color: "#008000"}}/>
    }
    else if(type == "error") {
        return <Icon type="close-circle" style={{color: "#FF0000"}}/>
    }
    else if(type == "warning") {
        return <Icon type="exclamation-circle" style={{color: "#FFC107"}}/> 
    }
    return icon
}

export const alertify = (title, content, type, options = {}) => {
    Modal[type]({
        className: options.hideFooter ? 'no-alertify-buttons' : '',
        title: title,
        content: content,
        centered: true,
        okText: options.okText || "Ok",
        onOk: options.onOk,
        closable: options.closable,
        cancelText: options.CancelText || "Close",
        onCancel: options.onCancel,
        icon: getModalIcon(type, options.icon)
    });
}

export const daterange_for_filter = (start, end, timeFormatRequired = true) => {
    const format = timeFormatRequired ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD";
    return [
        start.startOf('day').format(format),
        end.endOf('day').format(format)
    ]
}

export const printRupee = (amount, precision=2) => {
    return (
        <>
            <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} /> <span>{parseFloat(amount).toFixed(precision)}/-</span>
        </>
    )
}

export const goTo = (url, history, props) => {
    history.push({
    pathname: url,
    state: props
    });
}

export const goToEasebuzz = (url = "/") => {
    window.open(`${process.env.REACT_APP_EASEBUZZ_URL}${url}`, "_blank");
}

export const humanizeDate = (date, time = true) => {
    return moment(date).format(`LL${time ? "L" : ""}`);
}

export const getCookie = (name) => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

export const setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const default_avatar = () => {
    return require("./assets/images/avatar.jpg");
}

export const get_user_avatar = (user) => {
    return (user && user.avatar) || default_avatar();
}

export const titlize = (str) => {
    return str.toLowerCase().split(' ').map((word) => {
        return word.replace(word[0], word[0].toUpperCase());
    }).join(' ');
}

export const handleApiExceptions = (response) => {
    try {
        let error_message = "";
        if (typeof (response) == "string") error_message = response;
        else if (response && response.status && [401, 503].includes(response.status)) return;
        else if (response && response.message) error_message = response.message;
        else if (response && response.data && response.data.message) error_message = response.data.message;
        alertify("Oops!!!", error_message || "Something went wrong. Try again.", "error");
    } catch (error) {
        alertify("Oops!!!", "Something went wrong. Try again.", "error");
    }
}

export const size_greater_than = (file, size = 2048) => {
    if (!file instanceof File) {
        throw new Error("file must be an instance of File class");
    }
    return file.size > size;
}


export const generate_query_set = (Model, data) => {

    return data.map(o => new Model(o))
};


export const getIndianRupeeNotation = (amount, precision = 2) => {
    const rawAmount = amount.toFixed(precision).split(".");
    const integerAmountString = parseInt(rawAmount[0]).toLocaleString("en-IN");
    const decimalAmountString = parseInt(rawAmount[1]) ? rawAmount[1] : "0".repeat(precision);
    const amountString = `${integerAmountString}.${decimalAmountString}`;
    return {
        integer: integerAmountString,
        decimal: decimalAmountString,
        amount: amountString
    }
};

export const getRedirectPath = (permissions) => {
        if(permissions.includes('DASHBOARD_READ'))
        return '/';
        else if(permissions.includes('CONTACTS_READ'))
        return '/contacts';
        else if(permissions.includes('TRANSFERS_READ'))
        return '/transfers';
        else if(permissions.includes('BULK_OPERATIONS_READ'))
        return '/batches';
        else if(permissions.includes('ACCOUNT_STATEMENT_READ'))
        return '/ledger';
        else if(permissions.includes('INVOICES_READ'))
        return '/invoices';
        else if(permissions.includes('MERCHANTS_READ'))
        return '/merchants';
        else if(permissions.includes('USERS_READ'))
        return '/users';
        else if(permissions.includes('USERS_READ'))
        return '/users';
        else if(permissions.includes('TRANSFER_REQUEST_APPROVAL_READ'))
        return '/transfer_request_approval';
        else
        return '/';
    }

    export const beneficiaryNameRegex = () => {
        return /^([a-zA-Z0-9]+|(['\"]{1}[a-zA-Z0-9]+)|([ ]+[a-zA-Z0-9])+).*/
    }

    export const emailValidationRegex = () =>{
        return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
    }

    export const ifscValidationRegex = () =>{
        return /^[a-zA-Z]{4}0[a-zA-Z0-9]{6}$/
    }

    export const accountNumberValidationRegex = () =>{
        return /^(?!0+$)[a-zA-Z0-9]{0,}$/
    }

    export const phoneNumberValidationRegex = () =>{
        return /^[2-9]{1}\d{9}$/
    }

    export const upiHandleValidationRegex = () =>{
        return /^(?!.*\.{2})[A-Za-z0-9.-]+@[A-Za-z0-9.]+$/
    }

    export const amountValidationRegex = () =>{
        return /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/
    }

    export const udfValidationRegex = () =>{
        return '^[A-Za-z0-9]+$'
    }

    export const urlValidationRegex = () =>{
        return /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
    }

    export const nameValidationRegex = () =>{
        return /^(?![~@#$^*%()_+=[\]{}|\\,.?:'\" -]*$)([a-zA-Z0-9'\"][~@#$^*%()_+=[\]{}|\\,.?:'\" -&\/]{0,}[a-zA-Z0-9]*)+$/
    } 

    export const bankBranchValidationRegex = () =>{
        return /^(?![0-9\s]*$)[a-zA-Z0-9]+[a-zA-Z0-9\s\\,\(\.\)\/\-]*[a-zA-Z0-9,\\,\(\.\)\/\-]+$/
    } 

    export const percentageValidationRegex = () =>{
        return /^100(\.0{1,2})?$|(^([1-9]([0-9])?)(\.[0-9]{1,2})?)$/
    }

    export const addressValidationRegex = () =>{
        return '^[A-Za-z0-9.-/&, ]+$'
    }
    
    export const strictNameValidationRegex = () =>{
        return /^(?![0-9\s]*$)[a-zA-Z0-9]+[a-zA-Z0-9\s]*[a-zA-Z0-9]+$/
    }

export const getObjectFromArray = (arr, key, value) => {
    return arr.find(obj => obj[key] === value);
}